import React from "react";
import {
  Container,
  Row,
  Col,
  Card
} from "react-bootstrap";
import "./Awards.css";

export const Awards = () => {
const awardsData = [
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A19.jpg", 
      caption: 'BigFix Platinum Partner Awards (2025)',
      importance: "The highest partnership level, indicating mastery in endpoint management and a proven track record of large-scale deployments."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A20.jpg", 
      caption: 'BigFix APJ and India Business Partner Deal Master (2025)',
      importance: "Recognizes the ability to architect and close the most complex, high-value strategic enterprise deals across the Asia-Pacific region."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A14.jpg", 
      caption: 'BigFix Platinum Partner Awards (2024)',
      importance: "Sustained excellence in delivering HCL BigFix solutions with the highest level of technical certification and customer satisfaction."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A16.jpg", 
      caption: "BigFix Deal Master Awards (2024)",
      importance: "Awarded for exceptional sales strategy and the successful execution of critical endpoint security projects."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A17.jpg", 
      caption: "Solarwinds Excellence in Customers Awards (2024)",
      importance: "Highlights our commitment to post-implementation support and helping clients maximize their IT operations management (ITOM) visibility."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A1.png", 
      caption: "Solarwinds Partner Awards (2023)",
      importance: "Recognizes a year of consistent growth and deep expertise in deploying SolarWinds' comprehensive monitoring suite."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A2.jpg", 
      caption: "Solarwinds - Strategic Win (2019)",
      importance: "Commemorates the successful deployment of SolarWinds in a high-stakes, mission-critical enterprise environment."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A3.jpg", 
      caption: "Solarwinds - Top Seller (2020)",
      importance: "Awarded for leading the market in license volume and driving widespread adoption of observability tools."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A4.jpg", 
      caption: "HCL Specialised Partner of the year",
      importance: "A prestigious nod to our deep specialization in HCL’s software portfolio, specifically focusing on automation and security."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A5.jpeg", 
      caption: "Solarwinds - Significant Win",
      importance: "Marks a major milestone in acquiring and transforming the IT infrastructure of a key industry leader."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A6.jpeg", 
      caption: "Solarwinds - Authorized Award (2019)",
      importance: "Official recognition of our status as an authorized, certified partner for specialized product distribution."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A7.jpeg", 
      caption: "Solarwinds - Best acheivement of the year (2018)",
      importance: "An annual honor for exceeding all performance benchmarks in technical support and market penetration."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A8.jpeg", 
      caption: "Contribution to IBM C&SI Business ",
      importance: "Recognizes our instrumental role in growing IBM's Cloud & Smarter Infrastructure footprint through expert consultation."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A9.jpeg", 
      caption: "Solarwinds - Outstanding Sales Growth Reseller (2018)",
      importance: "Celebrates the fastest year-on-year growth among SolarWinds resellers in the region."
    },
    { 
      image: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/A11.jpeg", 
      caption: "Tech Innovator",
      importance: "Honors our drive to implement cutting-edge technology and custom automations for complex IT environments."
    }
  ];

  const processCaption = (text) => {
    const yearMatch = text.match(/\((\d{4})\)/);
    if (yearMatch) {
      return {
        title: text.replace(yearMatch[0], "").trim(),
        year: yearMatch[1],
      };
    }
    return { title: text, year: null };
  };

  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h2 className="awards-heading">Our Awards & Recognition</h2>
        <div className="heading-underline"></div>
      </div>

      <Row>
      {awardsData.map((award, index) => {
  const { title, year } = processCaption(award.caption);

  return (
    <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
      <div className="award-flip-card">
        <div className="award-flip-inner">

          {/* FRONT SIDE */}
          <div className="award-flip-front">
            <Card className="award-card h-100 border-0 shadow-sm">
              <div className="award-img-wrapper">
                <Card.Img
                  variant="top"
                  src={award.image}
                  className="award-img"
                  loading="lazy"
                />
              </div>
              <Card.Body className="text-center p-3">
                {year && <span className="award-year">{year}</span>}
                <Card.Title className="award-title mt-2">
                  {title}
                </Card.Title>
             
              </Card.Body>
            </Card>
          </div>

          {/* BACK SIDE */}
          <div className="award-flip-back">
            <div className="award-back-content">
              {year && <span className="award-year">{year}</span>}
              <h6 className="award-title">{title}</h6>
              <p className="award-description">
                {award.importance}
              </p>
            </div>
          </div>

        </div>
      </div>
    </Col>
  );
})}
      </Row>
    </Container>
  );
};
